import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { sortBy } from 'lodash-es';
import { Button, Spinner, Typography } from 'seagull';
import { useQboInVob } from '~/components/VendorOnboardingModal/useQboInVob';
import { useOnMount } from '~/hooks/useOnMount';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { Accounting, VobQboState } from '~/types/api.model';
import { StepTemplate } from '../StepTemplate';
import { Step } from '../VendorOnboardingModal.utils';
import { AccountRow, LinkType } from './AccountRow';
import styles from './QBOSetupStep.module.scss';
export function QBOSetupStep(props) {
    const { onContinue } = props;
    const { getQboAccounts, waitForReadyIntegration, setPendingConnect } = useQboInVob();
    const [qboAccounts, setQboAccounts] = useState();
    const [integration, setIntegration] = useState();
    useOnMount(()=>{
        setPendingConnect(VobQboState.Done);
    });
    useEffect(()=>{
        waitForReadyIntegration().then(async (integration)=>{
            const accounts = await getQboAccounts();
            const sortedAccounts = {
                bank: sortBy(accounts.bank, (account)=>account.name),
                expense: sortBy(accounts.expense, (account)=>account.name),
                clearing: sortBy(accounts.clearing, (account)=>account.name)
            };
            setQboAccounts(sortedAccounts);
            setIntegration(integration);
        });
    }, []);
    return /*#__PURE__*/ _jsx(StepTemplate, {
        currentStep: Step.QBOSetup,
        stepper: "Step 3 of 3",
        header: "Connect to ".concat(getAccountingDetails(Accounting.QBO).fullName),
        subHeader: "Choose the accounts you'd like to use. Don't worry, you can change it anytime.",
        footer: /*#__PURE__*/ _jsx("div", {
            className: styles.bottom,
            children: /*#__PURE__*/ _jsx(Button, {
                testId: "vob-step-".concat(Step.QBOSetup, "-continue"),
                onClick: ()=>onContinue(true),
                bi: {
                    name: 'continue_to_anchor'
                },
                children: "Continue to Anchor"
            })
        }),
        children: integration ? /*#__PURE__*/ _jsxs("div", {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(AccountRow, {
                    linkType: LinkType.Bank,
                    initialValue: integration === null || integration === void 0 ? void 0 : integration.getBankAccountId(),
                    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.bank) || undefined,
                    placeholder: "Choose a bank account for deposited funds",
                    noOptionsText: "No Savings or Checking accounts to show"
                }),
                /*#__PURE__*/ _jsx(AccountRow, {
                    linkType: LinkType.Expense,
                    initialValue: integration === null || integration === void 0 ? void 0 : integration.getExpenseAccountId(),
                    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.expense) || undefined,
                    placeholder: "Choose an expense account for merchant fees"
                }),
                /*#__PURE__*/ _jsx(AccountRow, {
                    linkType: LinkType.Clearing,
                    initialValue: integration === null || integration === void 0 ? void 0 : integration.getClearingAccountId(),
                    qboAccounts: (qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.clearing) || undefined,
                    placeholder: "Choose a clearing account for collected funds"
                })
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            "data-testid": "pending-accounts-spinner",
            className: styles.spinnerContainer,
            children: [
                /*#__PURE__*/ _jsx(Spinner, {}),
                /*#__PURE__*/ _jsx(Typography, {
                    children: "Just a moment, bringing QuickBooks data to you..."
                })
            ]
        })
    });
}
